import { PolylineF, PolylineProps } from "@react-google-maps/api";
import { forwardRef } from "react";
import { setRef } from "../helpers";

type Props = PolylineProps & { color?: string; showIcon: boolean };

export const SolidPolyline = forwardRef<google.maps.Polyline, Props>(
  ({ color = "#D35227", showIcon, options, ...props }, ref) => {
    return (
      <PolylineF
        onLoad={(p) => setRef(ref, p)}
        options={{
          geodesic: false,
          strokeOpacity: 1,
          strokeColor: color,
          icons: showIcon
            ? [
                {
                  icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: color,
                    strokeColor: color,
                    strokeOpacity: 1,
                    strokeWeight: 4,
                  },
                  fixedRotation: true,
                  offset: "100%",
                },
              ]
            : undefined,
          ...options,
        }}
        {...props}
      />
    );
  }
);

SolidPolyline.displayName = "SolidPolyline";